import React from "react";
import Select from "react-select";
import PropTypes from "prop-types";

const ItemQuantitySelect = ({ maxQuantity, defaultOption, updateCart }) => {
    const createDropdownOptions = () => {
        const options = [];

        for (let i = 1; i < maxQuantity + 1; i++) {
            let option = { value: i, label: i };
            options.push(option);
        }
        const defaultOptionSelect = {
            value: defaultOption,
            label: defaultOption,
        };

        const customDropdownStyles = {
            container: () => ({
                width: "65px",
            }),
            menu: () => ({
                width: "60px",
                position: "absolute",
                backgroundColor: "#fff",
                zIndex: "10",
            }),
            indicatorSeparator: () => ({
                display: "none",
            }),
            dropdownIndicator: () => ({
                color: "#111827",
                paddingRight: "12px",
                paddingTop: "8px",
            }),
        };

        return {
            options: options,
            defaultOption: defaultOptionSelect,
            style: customDropdownStyles,
        };
    };

    const options = createDropdownOptions();
    return (
        <Select
            styles={options.style}
            options={options.options}
            defaultValue={options.defaultOption}
            onChange={(val) => updateCart(val.value)}
        />
    );
};

ItemQuantitySelect.propTypes = {
    maxQuantity: PropTypes.number,
    defaultOption: PropTypes.number,
    updateCart: PropTypes.func,
};

export default ItemQuantitySelect;
